import React from "react";
import PropTypes from "prop-types";

/**
 * Link element
 * @type {React.SFC<{ to: string, children: any }>}
 */
const Link = ({ to, children, ...rest }) => (<a href={to} {...rest}>{children}</a>);

export { Link };

Link.propTypes = {
  to: PropTypes.string,
  children: PropTypes.element,
};



// WEBPACK FOOTER //
// ./assets/shared/components/link/index.jsx